(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yonex-bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    const cfgNode = root.querySelector('[data-bundle-config]');
    if (!cfgNode) return;
    let cfg;
    try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { return; }

    const discountPct = cfg.discountPct || 10;
    const mainPrice = cfg.mainProductPrice || 0;

    const cards = root.querySelectorAll('[data-bundle-toggle]');
    const totalEl = root.querySelector('[data-bundle-total]');
    const originalEl = root.querySelector('[data-bundle-original]');
    const originalRow = root.querySelector('[data-bundle-original-row]');
    const savingsEl = root.querySelector('[data-bundle-savings]');
    const savingsRow = root.querySelector('[data-bundle-savings-row]');
    const addBtn = root.querySelector('[data-bundle-add]');

    function fmtMoney(cents) {
      const v = Math.round(cents / 100);
      return v.toLocaleString('da-DK') + ' kr';
    }

    function recalc() {
      let addonsTotal = 0;
      let discountableTotal = 0;
      cards.forEach(card => {
        if (!card.classList.contains('is-checked')) return;
        const price = parseInt(card.dataset.basePrice, 10) || 0;
        addonsTotal += price;
        // Opstrengning (stringing service) is excluded from the 10% discount — matches the
        // Shopify YONEX-KIT-10 collection scope. Service card is identified by data-bundle-item.
        if (card.dataset.bundleItem !== 'stringing') {
          discountableTotal += price;
        }
      });
      const original = mainPrice + addonsTotal;
      const savings = Math.round(discountableTotal * discountPct / 100);
      const final = original - savings;

      if (savings > 0) {
        originalRow.hidden = false;
        savingsRow.hidden = false;
        originalEl.textContent = fmtMoney(original);
        savingsEl.textContent = '− ' + fmtMoney(savings);
      } else {
        originalRow.hidden = true;
        savingsRow.hidden = true;
      }
      totalEl.textContent = fmtMoney(final);

      // Enable add button always (main product is always there); show different label state
      addBtn.disabled = false;
      const addonCount = root.querySelectorAll('[data-bundle-toggle].is-checked').length;
      const label = addBtn.querySelector('.yonex-bundle__add-label');
      if (addonCount === 0) {
        label.textContent = 'Tilføj ketcher til kurv';
      } else {
        label.textContent = 'Tilføj kit (' + (addonCount + 1) + ' varer)';
      }
    }

    // ── Cascade: populate Farve options when Streng changes (bundle) ──
    function populateBundleFarve() {
      const strengSel = root.querySelector('[data-service-config] select[name="properties[Streng]"]');
      const farveSel = root.querySelector('[data-bundle-farve]');
      const farveRow = root.querySelector('[data-bundle-farve-row]');
      const debug = (...a) => console.log('[ybundle/farve]', ...a);
      debug('init', { strengSel: !!strengSel, farveSel: !!farveSel, farveRow: !!farveRow });
      if (!strengSel || !farveSel || !farveRow) return;
      const strengValue = strengSel.value;
      debug('streng value', strengValue);
      if (!strengValue || strengValue === 'Lad Eksperterne vælge') {
        farveRow.hidden = true;
        farveSel.innerHTML = '<option value="" disabled selected>Vælg farve</option>';
        return;
      }
      const sel = '[data-color-template="' + strengValue.replace(/"/g, '\\"') + '"]';
      const tplLocal = root.querySelector(sel);
      const tplDoc = document.querySelector(sel);
      const tpl = tplLocal || tplDoc;
      const allTpls = Array.from(document.querySelectorAll('[data-color-template]')).map(t => t.getAttribute('data-color-template'));
      debug('selector', sel, { tplLocal: !!tplLocal, tplDoc: !!tplDoc, allTemplatesOnPage: allTpls });
      if (!tpl) {
        // Show row anyway with a helpful message so we can diagnose
        farveSel.innerHTML = '<option value="" disabled selected>Ingen farver tilgængelige</option>';
        farveRow.hidden = false;
        return;
      }
      farveSel.innerHTML = '<option value="" disabled selected>Vælg farve</option>' + tpl.innerHTML;
      farveRow.hidden = false;
    }
    const bundleStrengSel = root.querySelector('[data-service-config] select[name="properties[Streng]"]');
    if (bundleStrengSel) {
      bundleStrengSel.addEventListener('change', populateBundleFarve);
      populateBundleFarve();
    }

    cards.forEach(card => {
      const btn = card.querySelector('[data-bundle-check]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const checked = card.classList.toggle('is-checked');
        btn.setAttribute('aria-pressed', checked ? 'true' : 'false');
        recalc();
      });

      const picker = card.querySelector('[data-variant-picker]');
      if (picker) {
        picker.addEventListener('click', e => e.stopPropagation());
        picker.addEventListener('change', () => {
          const opt = picker.options[picker.selectedIndex];
          if (!opt) return;
          card.dataset.variantId = picker.value;
          card.dataset.basePrice = opt.dataset.price || card.dataset.basePrice;
          const priceEl = card.querySelector('[data-display-price]');
          if (priceEl && opt.dataset.priceFormatted) {
            priceEl.textContent = opt.dataset.priceFormatted;
          }
          // Swap the card image to match the chosen variant
          if (opt.dataset.image) {
            const img = card.querySelector('.yonex-bundle__card-media img');
            if (img) {
              img.src = opt.dataset.image;
              img.srcset = '';
              if (opt.dataset.alt) img.alt = opt.dataset.alt;
            }
          }
          recalc();
        });
      }

      const racketPicker = card.querySelector('[data-racket-picker]');
      if (racketPicker) {
        racketPicker.addEventListener('click', e => e.stopPropagation());
        racketPicker.addEventListener('change', () => {
          const opt = racketPicker.options[racketPicker.selectedIndex];
          if (!opt) return;
          card.dataset.variantId = racketPicker.value;
          card.dataset.basePrice = opt.dataset.price || card.dataset.basePrice;
          card.dataset.handle = opt.dataset.handle || card.dataset.handle;
          const priceEl = card.querySelector('[data-display-price]');
          if (priceEl && opt.dataset.priceFormatted) priceEl.textContent = opt.dataset.priceFormatted;
          const img = card.querySelector('[data-racket-image]');
          if (img && opt.dataset.image) {
            img.src = opt.dataset.image;
            img.alt = opt.dataset.title || '';
          }
          const mediaLink = card.querySelector('[data-racket-link]');
          if (mediaLink && opt.dataset.url) mediaLink.href = opt.dataset.url;
          const titleLink = card.querySelector('[data-racket-title-link]');
          if (titleLink) {
            if (opt.dataset.url) titleLink.href = opt.dataset.url;
            if (opt.dataset.title) titleLink.textContent = opt.dataset.title;
          }
          recalc();
        });
      }
    });

    addBtn.addEventListener('click', async () => {
      if (addBtn.disabled) return;

      // Validate: required stringing card must have streng + farve (unless Eksperterne) + spænding picked
      const requiredCard = root.querySelector('[data-bundle-required="1"]');
      if (requiredCard) {
        const strengSel = requiredCard.querySelector('select[name="properties[Streng]"]');
        const farveSel = requiredCard.querySelector('select[name="properties[Farve]"]');
        const tensionSel = requiredCard.querySelector('select[name="properties[Spænding]"]');
        const strengVal = strengSel && strengSel.value;
        const farveRequired = strengVal && strengVal !== 'Lad Eksperterne vælge';
        let missing = false;
        if (!strengVal) missing = true;
        if (!tensionSel || !tensionSel.value) missing = true;
        if (farveRequired && (!farveSel || !farveSel.value)) missing = true;
        if (missing) {
          requiredCard.classList.add('is-invalid');
          requiredCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => requiredCard.classList.remove('is-invalid'), 1200);
          const label = addBtn.querySelector('.yonex-bundle__add-label');
          if (label) label.textContent = 'Vælg streng & spænding først';
          setTimeout(() => recalc(), 1500);
          return;
        }
      }

      addBtn.disabled = true;
      addBtn.classList.add('is-loading');

      const items = [];
      const bundleId = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

      // Collect stringing props from any service config (Streng/Spænding/Farve) up-front
      // so we can attach them to the main racket line too — staff sees stringing
      // instructions directly under the racket in Shopify admin + checkout.
      const stringingProps = {};
      root.querySelectorAll('[data-bundle-toggle].is-checked [data-service-config] [data-bundle-property]').forEach(s => {
        const m = (s.name || '').match(/properties\[(.+)\]/);
        if (m && s.value) stringingProps[m[1]] = s.value;
      });

      // Main product first — now carries the stringing instructions if any add-on requires them
      const mainProps = Object.assign({ _bundle: 'yonex-kit', _bundle_id: bundleId }, stringingProps);
      items.push({
        id: cfg.mainProductId,
        quantity: 1,
        properties: mainProps
      });

      // Then add-ons. For stringing add-on: prefix property keys with _ so they're
      // hidden from customer at checkout (Shopify convention). Staff still sees them
      // in admin. The racket line above carries the un-prefixed copy for customer visibility.
      root.querySelectorAll('[data-bundle-toggle].is-checked').forEach(card => {
        const id = parseInt(card.dataset.variantId, 10);
        if (!id) return;
        const props = { _bundle: 'yonex-kit', _bundle_id: bundleId };
        card.querySelectorAll('[data-service-config] [data-bundle-property]').forEach(s => {
          const m = (s.name || '').match(/properties\[(.+)\]/);
          if (m && s.value) props['_' + m[1]] = s.value;
        });
        items.push({
          id: id,
          quantity: 1,
          properties: props
        });
      });

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) throw new Error('add failed');

        // Bundle discount is now a Shopify Automatic Discount that triggers on any ketcher in cart.
        // No /discount/... call needed — Shopify handles it automatically at checkout.

        // Trigger Prestige cart refresh
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('on:cart:loaded'));

        // Open Prestige cart-drawer custom element
        const drawer = document.querySelector('cart-drawer, [is="cart-drawer"]');
        if (drawer && typeof drawer.show === 'function') {
          drawer.show();
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          const headerCartBtn = document.querySelector('[aria-controls="cart-drawer"], .header__cart-link');
          if (headerCartBtn) headerCartBtn.click();
        }

        addBtn.classList.remove('is-loading');
        const label = addBtn.querySelector('.yonex-bundle__add-label');
        label.textContent = '✓ Tilføjet til kurv';
        setTimeout(() => {
          addBtn.disabled = false;
          recalc();
        }, 1800);
      } catch (e) {
        console.error('[yonex-bundle] add error', e);
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
        const label = addBtn.querySelector('.yonex-bundle__add-label');
        label.textContent = 'Prøv igen';
      }
    });

    recalc();
  }

  function bootAll() {
    document.querySelectorAll('[data-yonex-bundle]:not([data-yonex-bundle-init])').forEach(root => {
      root.setAttribute('data-yonex-bundle-init', '1');
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', bootAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yonex-collection-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var wraps = root.querySelectorAll('.ycoll-hero__chips-wrap');
    wraps.forEach(function (wrap) {
      if (wrap.__yhInit) return;
      wrap.__yhInit = true;
      var toggle = wrap.querySelector('[data-yhchips-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var collapsed = wrap.hasAttribute('data-yhchips-collapsed');
        if (collapsed) {
          wrap.removeAttribute('data-yhchips-collapsed');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          wrap.setAttribute('data-yhchips-collapsed', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yonex-hero-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.yhcInit === '1') return;
    root.dataset.yhcInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-yhc-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-yhc-dot]'));
    var prevBtn = root.querySelector('[data-yhc-prev]');
    var nextBtn = root.querySelector('[data-yhc-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) autoplay = false;

    if (slides.length <= 1) return;

    // Expose interval to CSS for dot fill animation
    root.style.setProperty('--yhc-interval', interval + 'ms');

    var current = 0;
    var timer = null;
    var isPaused = false;

    function go(idx) {
      if (idx === current) return;
      idx = ((idx % slides.length) + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = idx;
      slides[current].classList.add('is-active');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
        // restart fill animation
        var fill = dots[current].querySelector('.yhc__dot-fill');
        if (fill) {
          fill.style.animation = 'none';
          // force reflow
          void fill.offsetWidth;
          fill.style.animation = '';
        }
      }
      if (autoplay) restart();
    }

    function next() { go(current + 1); }
    function prev() { go(current - 1); }

    var hasRotated = false;
    function start() {
      if (!autoplay || isPaused) return;
      clearInterval(timer);
      // First rotation kicks in faster (2.8s) so the carousel feels alive on page load
      var firstDelay = hasRotated ? interval : Math.min(2800, interval);
      timer = setTimeout(function tick() {
        next();
        hasRotated = true;
        timer = setTimeout(tick, interval);
      }, firstDelay);
    }
    function stop() { clearTimeout(timer); timer = null; }
    function restart() { stop(); start(); }

    // Wire controls
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        if (!isNaN(idx)) go(idx);
      });
    });

    // Pause on hover (desktop)
    root.addEventListener('mouseenter', function () { isPaused = true; stop(); });
    root.addEventListener('mouseleave', function () { isPaused = false; start(); });

    // Pause when tab hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Keyboard nav when section in view
    document.addEventListener('keydown', function (e) {
      var r = root.getBoundingClientRect();
      var inView = r.top < window.innerHeight && r.bottom > 0;
      if (!inView) return;
      if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });

    // Touch swipe
    var startX = null;
    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) {
        if (dx < 0) next(); else prev();
      }
      startX = null;
    });

    start();
  }

  function bootAll() {
    document.querySelectorAll('[data-yhc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', bootAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yonex-pro-roster"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root) {
    if (root.__yrInit) return;
    root.__yrInit = true;

    const track = root.querySelector('[data-yroster-track]');
    const cards = Array.from(root.querySelectorAll('[data-yroster-card]'));
    const prevBtn = root.querySelector('[data-yroster-prev]');
    const nextBtn = root.querySelector('[data-yroster-next]');
    const counter = root.querySelector('[data-yroster-current]');
    const progress = root.querySelector('[data-yroster-progress]');

    if (!track || !cards.length) return;

    const total = cards.length;
    let activeIdx = 0;

    function setActive(idx, scroll) {
      activeIdx = Math.max(0, Math.min(total - 1, idx));
      cards.forEach((c, i) => c.classList.toggle('is-active', i === activeIdx));
      if (counter) counter.textContent = String(activeIdx + 1);
      if (progress) {
        const pct = ((activeIdx + 1) / total) * 100;
        progress.style.setProperty('--p', pct + '%');
      }
      if (prevBtn) prevBtn.disabled = activeIdx === 0;
      if (nextBtn) nextBtn.disabled = activeIdx === total - 1;
      if (scroll && cards[activeIdx]) {
        cards[activeIdx].scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      }
    }

    cards.forEach((c, i) => {
      c.addEventListener('mouseenter', () => setActive(i, false));
      c.addEventListener('focus', () => setActive(i, false));
    });

    if (prevBtn) prevBtn.addEventListener('click', () => setActive(activeIdx - 1, true));
    if (nextBtn) nextBtn.addEventListener('click', () => setActive(activeIdx + 1, true));

    // Sync active to scroll position
    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const rect = track.getBoundingClientRect();
        const center = rect.left + rect.width * 0.25;
        let closest = 0;
        let dist = Infinity;
        cards.forEach((c, i) => {
          const r = c.getBoundingClientRect();
          const d = Math.abs(r.left - center);
          if (d < dist) { dist = d; closest = i; }
        });
        if (closest !== activeIdx) setActive(closest, false);
      }, 100);
    });

    setActive(0, false);
  }

  function bootAll() {
    document.querySelectorAll('.yroster').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', bootAll);
})();

  } catch(e) { console.error(e); }
})();
})();
